import { NgModule } from "@angular/core";

import { ColorPasswordComponent } from "./color-password.component";

@NgModule({
  imports: [ColorPasswordComponent],
  exports: [ColorPasswordComponent],
})
export class ColorPasswordModule {}
